import 'angular';

import { MechanicCtrl }        from './mechanic';
import { MechanicClockOnCtrl } from './mechanic.clock-on';
import { MechanicLookupCtrl }  from './mechanic.lookup';
import { MechanicsCtrl }       from './mechanics';
import { MechanicsStates }     from './mechanics.states.ajs';

angular.module('workshop.mechanics', [])
.config(MechanicsStates)
.controller('MechanicClockOnCtrl', MechanicClockOnCtrl)
.controller('mechanicCtrl', MechanicCtrl)
.controller('mechanicLookupCtrl', MechanicLookupCtrl)
.controller('MechanicsCtrl', MechanicsCtrl);